var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRondPoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.954,
    height: 32,
    viewBox: "0 0 32.954 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rond-point",
    transform: "translate(-55.5 -486.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    transform: "translate(62.64 493.64)",
    fill: "none",
    stroke: "#ffc43e",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.337,
    cy: 9.337,
    r: 9.337,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.337,
    cy: 9.337,
    r: 6.837,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_25",
    "data-name": "Ligne 25",
    y2: 9,
    transform: "translate(71.977 486.977)",
    fill: "none",
    stroke: "#ffc43e",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_26",
    "data-name": "Ligne 26",
    y2: 9,
    transform: "translate(71.977 509.977)",
    fill: "none",
    stroke: "#ffc43e",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_27",
    "data-name": "Ligne 27",
    y2: 9.886,
    transform: "translate(88.454 502.977) rotate(90)",
    fill: "none",
    stroke: "#ffc43e",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_28",
    "data-name": "Ligne 28",
    y2: 9.886,
    transform: "translate(65.386 502.977) rotate(90)",
    fill: "none",
    stroke: "#ffc43e",
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRondPoint);
export default __webpack_public_path__ + "static/media/rond-point.103f2d846846ba6fa1dafb046c5d692a.svg";
export { ForwardRef as ReactComponent };